import { createAction, createSlice } from "@reduxjs/toolkit";
// import { apiEndpoints } from "../api";
// import { apiCallBegan } from "./apiActions";

import messagesService from "../services/messagesService";
import { countUserPosts } from "./channels";

import { ADD_ERROR } from "./errors";

//%-<<*----------  NEEDED ENDPOINTS FOR THIS PARTICULAR REDUCER  ----------*>>-%//

// const {} = apiEndpoints;

//%-<<*----------  REDUCERS AND ACTION TYPES  ----------*>>-%//

const messagesSlice = createSlice({
    name: "messages",
    initialState: { messages: [], filteredMessages: [], searchFiltering: false, typingUsers: [], loading: false },

    reducers: {
        START_LOADING: messages => {
            messages.loading = true;
        },

        CREATE_MESSAGE: (messages, { payload }) => {
            Object.assign(messages, {
                // messages: [...messages.messages, payload],
                loading: false,
                filteredMessages: [],
                searchFiltering: false,
            });
        },

        GET_MESSAGES: (messages, { payload }) => {
            Object.assign(messages, {
                messages: payload,
                loading: false,
                filteredMessages: [],
                typingUsers: [],
                searchFiltering: false,
            });
        },

        DELETE_MESSAGES: (messages, { payload }) => {
            messages.loading = false;
        },

        START_FILTERING: messages => {
            messages.searchFiltering = true;
        },

        END_FILTERING: messages => {
            messages.searchFiltering = false;
        },

        FILTER_MESSAGES: (messages, { payload }) => {
            messages.filteredMessages = payload;
        },

        UPDATE_TYPING_USERS: (messages, { payload }) => {
            messages.typingUsers = payload;
        },

        ADD_NEW_MESSAGES: (messages, { payload }) => {
            Object.assign(messages, {
                messages: payload,
                filteredMessages: [],
                searchFiltering: false,
            });
        },
    },
});

export default messagesSlice.reducer;

//%-<<*----------  ACTIONS TYPES  ----------*>>-%//

const {
    CREATE_MESSAGE,
    GET_MESSAGES,
    DELETE_MESSAGES,
    START_FILTERING,
    END_FILTERING,
    FILTER_MESSAGES,
    UPDATE_TYPING_USERS,
    ADD_NEW_MESSAGES,
    START_LOADING,
} = messagesSlice.actions;

//%-<<*----------  API -- ACTIONS  ----------*>>-%//

export const createMessage = data => async dispatch => {
    try {
        dispatch({ type: CREATE_MESSAGE.type, payload: await messagesService.createMessage(data) });
    } catch ({ message }) {
        dispatch({ type: ADD_ERROR.type, payload: { name: createMessage.name, message } });
    }
};

export const getCurrentChannelMessages = channelId => async (dispatch, getState) => {
    dispatch({ type: START_LOADING.type });

    dispatch({ type: GET_MESSAGES.type, payload: await messagesService.getCurrentChannelMessages(channelId) });

    dispatch(countUserPosts(getState().messages.messages));
};

export const deleteMessages = channelId => async dispatch => {
    dispatch({ type: DELETE_MESSAGES.type, payload: await messagesService.deleteChannelMessages(channelId) });
};

export const filterMessages = createAction(FILTER_MESSAGES.type);

export const startFiltering = createAction(START_FILTERING.type);

export const endFiltering = createAction(END_FILTERING.type);

export const updateTypingUsers = createAction(UPDATE_TYPING_USERS.type);

export const addNewMessageToCurrentChannel = messages => (dispatch, getState) => {
    if (getState().messages.loading) return;

    dispatch({ type: ADD_NEW_MESSAGES.type, payload: messages });

    dispatch(countUserPosts(getState().messages.messages));
};
